import React from 'react';
import { Collapse } from '@mui/material';
import { ArcCollapseProps } from './types';

const ArcCollapse: React.FC<ArcCollapseProps> = (props) => {
  const { children, sx, ...rest } = props;
  return (
    <Collapse sx={sx} {...rest}>
      {children}
    </Collapse>
  );
};

export default ArcCollapse;